// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WWWNs","footer":"styles_footer__1Yd6Z","passCodeTooltip":"styles_passCodeTooltip__2VaDR"};